import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CompanyPubrOperations, CompanyPubrSelectors } from '@panel/usuarios/src/store/ducks/myCompany';
import { userInfoSelectors } from '../state/ducks/user';

const useContactOwner = () => {
  const [showOwner, setShowOwner] = useState(false);

  const isInProfessionalPublisher = window.location.href.includes('publicador-profesionales');
  const { publisherTypeId, userTypeId } = useSelector(userInfoSelectors.getuserInfoState);
  const { fetchedAgent, agent, owner } = useSelector(CompanyPubrSelectors.getCompanyPubr);
  const dispatch = useDispatch();
  const enabledSites = useMemo(() => ['ZPAR', 'CMBR', 'ICBR', 'IWBR', 'WIBR', '24MX', 'PLEC', 'CAPA', 'UBPE'], []);
  const sitesDefault = useMemo(() => ['ZPAR', 'IWBR', 'ICBR', 'CMBR', 'UBPE'], []);
  const site = process.env.REACT_APP_BUILD_SITE;

  useEffect(() => {
    if (enabledSites.includes(site)) {
      if (
        publisherTypeId &&
        publisherTypeId !== '1' &&
        userTypeId === '1' &&
        !showOwner &&
        !isInProfessionalPublisher
      ) {
        setShowOwner(true);
      }
    }
  }, [
    agent,
    dispatch,
    enabledSites,
    isInProfessionalPublisher,
    owner,
    publisherTypeId,
    showOwner,
    site,
    sitesDefault,
    userTypeId
  ]);

  const getAgentData = useCallback(() => {
    if (!fetchedAgent) {
      dispatch(
        CompanyPubrOperations.api({
          controller: 'publisher',
          method: 'AGENT',
          path: 'salesforce/me',
          modal: 'owner',
          owner: true
        })
      );
    }
  }, [fetchedAgent, dispatch]);
  return {
    showOwner,
    getAgentData
  };
};

export { useContactOwner };
